import { CommonResponse } from "@gtpl/shared-models/masters";
import connection from "./connection";
import axios from "axios";
import { TabNameReq, WorkOrderInfoReq, WorkOrderReq } from "@gtpl/shared-models/raw-material-procurement";

export class WorkOrderService {
    URL = connection.DEPLOY_URL + '/work-order-generation';
    //     userid = connection.userid;
    //   role=connection.role;
    //   unitId=connection.unit_id;

    async getOpenBaleDetails(req:WorkOrderInfoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getOpenBaleDetails', req)
            .then(res => {
                return res.data
            })
    }

        async createWorkOrder(req: WorkOrderReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createWorkOrder', req)
            .then(res => {
                return res.data;
            }).catch(err => {
                console.log(err);
                throw err; 
            });
    }

     async getVoucherNumberDropDownInfo(req:TabNameReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getVoucherNumberDropDownInfo',req)
            .then(res => {
                return res.data
            })
    }

    async getAgentDropDownInfo(req:TabNameReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAgentDropDownInfo',req)
            .then(res => {
                return res.data
            })
    }

    async getBaleNumberDropDownInfo(req:TabNameReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBaleNumberDropDownInfo',req)
            .then(res => {
                return res.data
            })
    }

        async getWONumberDropDownInfo(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getWONumberDropDownInfo')
            .then(res => {
                return res.data
            })
    }

        async getWorkOrderInfo(req:WorkOrderInfoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getWorkOrderInfo',req)
            .then(res => {
                return res.data
            })
    }

}